import 'react-multi-carousel/lib/styles.css';

import * as commonActions from '../../common/redux/actions';
import * as homeActions from '../../home/redux/actions';
import * as myAccountActions from '../../my-account/redux/actions';
import * as serviceActions from '../../pb-service-list/redux/actions';

import { KuposButton, KuposModal, SvgHome } from '../../common';
import React, { useEffect, useState } from 'react';
import { ThemeElevenSearchBox, ThemeElevenTitle } from '..';

import ApiUrls from '../../../services/apiUrls';
import Carousel from 'react-multi-carousel';
import HeroSection from '../common/HeroSection/HeroSection';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../functions/getIcons/getIcons';
import { useTranslation } from 'react-i18next';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const ThemeEleven = ({ history, operator, home, actions }) => {
  const { t, i18n} = useTranslation("common");
  localStorage.removeItem('paymentGatewayOpened');
  sessionStorage.removeItem('paymentCounter');
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [centropuertoResponseModal, setCentropuertoResponseModal] = useState(false);
  const currentLanguage = i18n.language;


  useEffect(() => {
    actions.pbSetSourceCity(null);
    actions.pbSetDestinationCity(null);
  }, []);

  const onKnowYourRoutesClick = v => {
    if (home.uniqueCities) {
      setLoader(v);

      const originCity = home.uniqueCities.find(city => city.value === v.id);
      const originDestination = home.uniqueCities[home.uniqueCities.length - 1];

      const selectedService = services.find(service => service.id === v.id);

      if (selectedService) {
        const originId = selectedService.originId;
        const destinationId = 1;

        const arr = Array.from({ length: 1 }, (_, index) => ({ number: index + 1 }));

        actions.selectSeatOnward({ selectedSeatsToBook: arr });

        actions.apiCall({
          type: 'home',
          url: ApiUrls.getTariffTheme11({
            originId,
            destinationId,
            noOfPassengers: 1,
          }),
          callback: res => {
            setLoader(false);
            if (res && res.data) {
              if (res.data.success) {
                sessionStorage.setItem('tariffData', JSON.stringify(res.data.data.tariff));
                actions.pbSetSourceCity(originCity);
                actions.pbSetDestinationCity(originDestination);
                history.push('/terminal/booking');
              } else if (res.data.errors) {
                setCentropuertoResponseModal(res.data.errors.error);
              }
            }
          },
          method: 'GET',
        });
      }
    }
  };

  const services = [
	{
		img: (t("HOME.RUTALOSBLUE")),
		img2: (t("HOME.RUTALOSWHITE")),
		link: '/los',
		id: 1,
		originId: 2,
	},
	{
		img: (t("HOME.RUTAPAJARITOSBLUE")),
		img2: (t("HOME.RUTAPAJARITOSWHITE")),
		link: '/pajaritos',
		id: 2,
		originId: 4,
	},
	{
		img: (t("HOME.RUTATERMINALBLUE")),
		img2: (t("HOME.RUTATERMINALWHITE")),
		link: '/terminalsur',
		id: 3,
		originId: 5,
	},
	{
		img: (t("HOME.RUTAMAIPUBLUE")),
		img2: (t("HOME.RUTAMAIPUWHITE")),
		link: '/maipu',
		id: 4,
		originId: 3,
	},
];

  return (
    <div className="theme-eleven">
      <div style={{ position: 'relative', marginBottom: 150 }}>
        <HeroSection height={'74vh'} heroImage={t("HOME.HOME_BANNER")} />
        <div className="searchboxoverlay">
          <ThemeElevenSearchBox
            loading={loading}
            setLoading={setLoading}
            history={history}
            operator={operator}
          />
        </div>
      </div>

      <ThemeElevenTitle operator={operator} smallHeading={t("HOME.SMALL_HEADING")} boldHeading={t("HOME.BOLD_HEADING")}  />

      <div className="new-container">
        <Carousel
          responsive={responsive}
          swipeable={false}
          draggable={false}
          showDots={false}
          infinite={true}
          autoPlay={false}
          autoPlaySpeed={1000}
          customTransition="all .3"
          transitionDuration={1000}
          removeArrowOnDeviceType={['desktop', 'tablet', 'mobile']}
        >
          {services.map(v => (
            <div key={v.id}>
              <img src={v.img} alt="" style={{ objectFit: 'cover' }} />
              <img src={v.img2} style={{ marginTop: -20 }} alt="" />
              <div
                className="font12"
                style={{
                  position: 'absolute',
                  top: '55%',
                  left: '35%',
                  zIndex: '100',
                  color: 'rgb(255, 199, 44)',
                  fontWeight: 'bolder',
                  cursor: 'pointer',
                }}
              >
                <a
                  href={v.link}
                  style={{
                    color: 'rgb(255, 199, 44)',
                    fontWeight: 'bolder',
                  }}
                >
                  <span>{t("HOME.RUTA")}</span>
                </a>
              </div>
              <KuposButton
                onClick={() => onKnowYourRoutesClick(v)}
                className="service-button font12"
                style={{
					background: !loader
						? operator && operator.color_codes && operator.color_codes.button_color
							? operator.color_codes.button_color
							: ''
						: 'gray',
					borderRadius: 50,
				}}
                disabled={!!loader}
              >
                {!!loader && loader.id === v.id ? (
                  <div className="loader-cricle"></div>
                ) : (
                  <React.Fragment>
                    {t("HOME.COMPRAR")}
                  </React.Fragment>
                )}
              </KuposButton>
            </div>
          ))}
        </Carousel>
      </div>

      <div className="banner" style={{ marginTop: 50, marginBottom: -10 }}>
        <img src={t("HOME.SERVICE_BANNER")} alt="" style={{ objectFit: 'cover' }} />
      </div>
      <div className="common-bip-info-modal">
        <KuposModal
          showModal={!!centropuertoResponseModal}
          onHide={() => setCentropuertoResponseModal(false)}
          size="md"
          ariaLabel="login-modal"
        >
          <div className="bip-info-modal-container">
            <div className="close-button pointer" onClick={() => setCentropuertoResponseModal(false)}>
              <SvgHome name="close" />
            </div>
            {centropuertoResponseModal}
          </div>
        </KuposModal>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...serviceActions, ...myAccountActions, ...commonActions, ...homeActions },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeEleven);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/ThemeEleven.js